<section class="subhero">
    <div class="container">
        <div class="row">
            <h2>Materiais</h2>
        </div>
    </div>
</section>
<div class="container content">
    <div class="row">
        <div class="col">
            <h3>Assista a animação Tempo na Vida</h3>
            <p class="clear spacer-30-both">Nesta área estão expostos os materiais de apoio do projeto.</p>

            <p style="padding-bottom: 0pt; padding-top: 0pt; " class="paragraph_style_3"><a class="class2"
                                                                                            title="assets/files/Apostila TNV Revisada em 27_02.pdf"
                                                                                            href="assets/files/Apostila%20TNV%20Revisada%20em%2027_02.pdf" target="_blank">Apostila
                atualizada do projeto “O tempo na vida”</a></p>

            <p style="padding-top: 0pt; " class="paragraph_style_3">Download dos mapas conceituais:<br></p>
            <p class="paragraph_style_3"><br></p>
            <p style="padding-bottom: 0pt; " class="paragraph_style_3"><a class="class3" title="assets/files/mapa_infantil.pdf"
                                                                          href="assets/files/mapa_infantil.pdf" target="_blank">Ensino infantil</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a class="class4" title="assets/files/ensino_fundamental.pdf" href="assets/files/ensino_fundamental.pdf" target="_blank">Ensino fundamental</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a class="class5" title="assets/files/ensino_medio.pdf" href="assets/files/ensino_medio.pdf" target="_blank">Ensino médio</a></p>

        </div>
    </div>
</div>